module.exports = __webpack_public_path__ + "img/question_banner.568cb6e6.png";